import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamConnectionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createTeamConnection = (data, callbackFunction = undefined): any => action(types.CREATE_TEAM_CONNECTION_REQUESTED, {
  data,
  callbackFunction,
});

export const updateTeamConnection = (data, callbackFunction = undefined): any => action(types.UPDATE_TEAM_CONNECTION_REQUESTED, {
  data,
  callbackFunction,
});

export const deleteTeamConnection = (teamConnectionId): any => action(types.DELETE_TEAM_CONNECTION_REQUESTED, teamConnectionId);

export const getTeamConnection = (teamConnectionId): any => action(types.GET_TEAM_CONNECTION_REQUESTED, teamConnectionId);

export const getAllTeamConnections = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAM_CONNECTIONS_REQUESTED, { pagination, compile });

export const getAllTeamConnectionsTeamConnectionView = (
  pagination: IPagination = undefined,
  compile = true,
  teamCode = undefined,
  teamConnectionCode = undefined,
): any => action(types.GET_ALL_TEAM_CONNECTIONS_REQUESTED, {
  pagination,
  compile,
  teamConnectionView: true,
  teamCode,
  teamConnectionCode,
});

export const selectTeamConnection = (teamConnectionId): any => action(types.SELECT_TEAM_CONNECTION_REQUESTED, {
  currentTeamConnectionId: teamConnectionId,
});
export const clearTeamConnections = (): any => action(types.CLEAR_TEAM_CONNECTIONS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createTeamConnectionPending: (payload): any => action(types.CREATE_TEAM_CONNECTION_PENDING, payload),
  createTeamConnectionSuccess: (response): any => action(types.CREATE_TEAM_CONNECTION_SUCCESS, {
    teamConnectionsById: response.entities.teamConnections,
    currentTeamConnectionId: response.result,
  }),
  updateTeamConnectionPending: (payload): any => action(types.UPDATE_TEAM_CONNECTION_PENDING, payload),
  updateTeamConnectionSuccess: (response): any => action(types.UPDATE_TEAM_CONNECTION_SUCCESS, {
    teamConnectionsById: response.entities.teamConnections,
    currentTeamConnectionId: response.result,
  }),
  updateTeamConnectionFailed: (error): any => action(types.UPDATE_TEAM_CONNECTION_FAIL, { backendErrors: error }),
  deleteTeamConnectionPending: (response): any => action(types.DELETE_TEAM_CONNECTION_PENDING, response),
  deleteTeamConnectionSuccess: (response): any => action(types.DELETE_TEAM_CONNECTION_SUCCESS, {
    currentTeamConnectionId: response,
  }),
  getTeamConnectionPending: (): any => action(types.GET_TEAM_CONNECTION_PENDING, {}),
  getTeamConnectionSuccess: (response): any => action(types.GET_TEAM_CONNECTION_SUCCESS, {
    teamConnectionsById: response.entities.teamConnections,
    currentTeamConnectionId: response.result,
  }),
  getTeamConnectionFailed: (error): any => action(types.GET_TEAM_CONNECTION_FAIL, { backendErrors: error }),
  deleteTeamConnectionFailed: (error): any => action(types.DELETE_TEAM_CONNECTION_FAIL, { backendErrors: error }),
  getAllTeamConnectionsPending: (pagination): any => action(types.GET_ALL_TEAM_CONNECTIONS_PENDING, { pagination }),
  getAllTeamConnectionsSuccess: (response, meta): any => action(types.GET_ALL_TEAM_CONNECTIONS_SUCCESS, {
    teamConnectionsById: response.entities.teamConnections,
    teamConnectionIds: response.result,
    meta,
  }),
  getAllTeamConnectionsFailed: (error): any => action(types.GET_ALL_TEAM_CONNECTIONS_FAIL, { backendErrors: error }),
  createTeamConnectionFailed: (error): any => action(types.CREATE_TEAM_CONNECTION_FAIL, { backendErrors: error }),
};

export default null;
